import {Feature, GeoJSON} from "geojson";
import {IEntityViewNode} from "../store/reducers/loadLayerData";

export function createFeatureFromViewNode (node: Partial<IEntityViewNode & {geojson: GeoJSON}>): Feature {
    const properties = {...node};
    delete properties.stAsgeojson;
    return {
        type: 'Feature',
        geometry: node.geojson ? node.geojson : JSON.parse(node.stAsgeojson!),
        properties,
    };
}